module.exports = __webpack_public_path__ + "img/oncoprint.2d2cc8c6.svg";